import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { views } from 'enums/menu-enums';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const SelectedTab = ({ openOrders, completedOrders, table, tab }) => {
  return (
    <React.Fragment>
      {table === views.open && tab === 'confirm' && (
        <SelectedTab.FirstTab>
          {'Confirm'}
          <SelectedTab.Count>{openOrders}</SelectedTab.Count>
        </SelectedTab.FirstTab>
      )}
      {table === views.open && tab === 'toShip' && (
        <SelectedTab.SecondTab>
          {'To Ship'}
          <SelectedTab.Count>{openOrders}</SelectedTab.Count>
        </SelectedTab.SecondTab>
      )}
      {table === views.open && tab === 'shipped' && (
        <SelectedTab.ThirdTab>
          {'Shipped'}
          <SelectedTab.Count>{openOrders}</SelectedTab.Count>
        </SelectedTab.ThirdTab>
      )}
      {table === views.open && tab === 'all' && <SelectedTab.FourthTab>All</SelectedTab.FourthTab>}
      {table === views.completed && tab === 'delivered' && (
        <SelectedTab.FirstTab>
          {'Delivered'}
          <SelectedTab.Count>{completedOrders}</SelectedTab.Count>
        </SelectedTab.FirstTab>
      )}
      {table === views.completed && tab === 'returned' && (
        <SelectedTab.SecondTab>
          {'Returned'}
          <SelectedTab.Count>{completedOrders}</SelectedTab.Count>
        </SelectedTab.SecondTab>
      )}
      {table === views.completed && tab === 'canceled' && (
        <SelectedTab.ThirdTab>
          {'Canceled'}
          <SelectedTab.Count>{completedOrders}</SelectedTab.Count>
        </SelectedTab.ThirdTab>
      )}
      {table === views.completed && tab === 'all' && (
        <SelectedTab.FourthTab>All</SelectedTab.FourthTab>
      )}
    </React.Fragment>
  );
};

SelectedTab.TabBase = styled.div`
  position: absolute;
  letter-spacing: 1px;
  margin-top: -54px;
  font-size: 14px;
  font-weight: 500;
  font-family: ${FONTS.default};
  width: 190px;
  color: ${COLORS.primaryText};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55px;
  border: 1px solid ${COLORS.primaryTabBorder};
  border-bottom: 0;
  cursor: pointer;
  background-color: ${COLORS.primaryBackground};
  text-transform: uppercase;
`;

SelectedTab.FirstTab = styled(SelectedTab.TabBase)`
  margin-left: -1px;
  width: 192px;
  box-shadow: -3px -3px 8px 0px rgba(0, 0, 0, 0.1);
`;

SelectedTab.SecondTab = styled(SelectedTab.TabBase)`
  margin-left: 186px;
  width: 191px;
  box-shadow: -3px -3px 8px -1px rgba(0, 0, 0, 0.1);
`;

SelectedTab.ThirdTab = styled(SelectedTab.TabBase)`
  margin-left: 375px;
  box-shadow: -3px -3px 8px 0px rgba(0, 0, 0, 0.1);
`;

SelectedTab.FourthTab = styled(SelectedTab.TabBase)`
  margin-left: 564px;
  box-shadow: -3px -3px 8px 0px rgba(0, 0, 0, 0.1);
`;

SelectedTab.Count = styled.div`
  width: 30px;
  height: 30px;
  font-family: ${FONTS.emphasized};
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  text-align: center;
  color: ${COLORS.primaryText};
  border: 1px solid ${COLORS.secondaryTabBorder};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 34px;
`;

SelectedTab.propTypes = {
  tab: PropTypes.string,
  openOrders: PropTypes.number,
  completedOrders: PropTypes.number,
  table: PropTypes.string,
};

export default SelectedTab;
